package dev.lingvo.ops.state

import dev.lingvo.shared.ops.OpsJobState
import dev.lingvo.shared.ops.OpsMtJobRowDto
import dev.lingvo.shared.ops.OpsMtLeaseDto

fun leaseNote(lease: OpsMtLeaseDto?): String? {
    val age = lease?.heartbeatAgeSeconds ?: return null
    if (age <= lease.leaseSeconds) return null
    return "The last heartbeat is $age seconds old, beyond the ${lease.leaseSeconds}-second lease."
}

fun jobRiskOrder(rows: List<OpsMtJobRowDto>): List<OpsMtJobRowDto> = rows.sortedBy {
    when (it.state) {
        OpsJobState.ABANDONED -> 0
        OpsJobState.FAILED -> 1
        OpsJobState.RUNNING -> 2
        else -> 3
    }
}

fun refundedLabel(state: OpsJobState, refundedCredits: Int?): String = when {
    refundedCredits == null -> "Not refunded"
    else -> refundedCredits.toString()
}
